/**
 * Created by tofaelraju on 10/15/17.
 */

import React from 'react';

import List from './list';
import ListTop from './list-top.component';

const AppList =({title, listId, reactTableProps, addNewBtnLabel, addNewBadge, onCreateNew, noFilter})=>(
  <div>
    <ListTop
      title={title}
      onCreateNew={onCreateNew}
      createNewBadge={addNewBadge}
      createNewButtonLabel={addNewBtnLabel}
    />
    <List
      listId={listId}
      reactTableProps={reactTableProps}
      noFilter={noFilter}
    />
  </div>
);

export default AppList;


// WEBPACK FOOTER //
// ./src/screens/list/index.js